import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('white')};
  padding: ${spacing('xl4')} 0;
  text-align: center;
`;

export const StyledTitle = styled.h3`
  margin-top: 0;
  margin-bottom: ${spacing('md')};
  font-size: ${fontSize('md')};
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  letter-spacing: 0.35em;
`;

export const StyleAll = styled.div`
  margin-top: ${spacing('xl4')};
`;

export const StyledLogos = styled.div`
  margin-top: ${spacing('xl2')};
  height: ${spacing('xl')};
  overflow: hidden;
  position: relative;

  @media (min-width: ${screen('lg')}) {
    height: ${spacing('xl3')};
  }

  &::before,
  &::after {
    content: '';
    height: ${spacing('xl3')};
    position: absolute;
    width: ${spacing('xl5')};
    z-index: 2;
    background: linear-gradient(
      to right,
      rgba(250, 249, 255, 1) 0%,
      rgba(250, 249, 255, 0) 100%
    );
  }

  &::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }

  &::before {
    left: 0;
    top: 0;
  }

  > div {
    animation: scroll 40s linear infinite;
    display: flex;
    gap: ${spacing('xl5')};
  }

  &.reverse > div {
    animation-direction: reverse;
  }

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

export const StyledLogoItem = styled.div`
  flex-shrink: 0;
  height: ${spacing('xl')};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${screen('lg')}) {
    height: ${spacing('xl3')};
  }

  img {
    height: ${spacing('mdlg')};
    width: auto;
    display: block;

    @media (min-width: ${screen('lg')}) {
      height: ${spacing('xl2')};
    }
  }
`;

export const StyledMore = styled.div`
  margin: ${spacing('xl')} auto 0;
  font-size: ${fontSize('md')};
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  letter-spacing: 0.35em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs')};

  max-width: ${container('md')};

  &::before,
  &::after {
    content: '';
    height: 1px;
    background-color: ${color('midnight_200')};
    flex-grow: 1;
  }
`;
